module.exports = __webpack_public_path__ + "static/media/blog-2.6bc8da9a.jpg";